export const tckValidation = (tckn: string): boolean => {
    if (!/^\d{11}$/.test(tckn)) return false;

    const digits = tckn.split("").map(Number);
    if (digits.length !== 11) return false;

    if (digits[0] === 0) return false;

    const sumOdd = digits[0]! + digits[2]! + digits[4]! + digits[6]! + digits[8]!;
    const sumEven = digits[1]! + digits[3]! + digits[5]! + digits[7]!;

    const digit10 = ((sumOdd * 7) - sumEven) % 10;
    if (digits[9] !== digit10) return false;

    const sumFirst10 = digits.slice(0, 10).reduce((acc, val) => acc + val, 0);
    const digit11 = sumFirst10 % 10;
    if (digits[10] !== digit11) return false;

    return true;
};

export const emailValidation = (email: string): boolean => {
    if(!email) {
        return false;
    }

    const cleanEmail = email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(cleanEmail);
};

export const phoneValidation = (phone: string): boolean => {
    if(!phone) {
        return false;
    }

    let cleanPhone = phone.replace(/\D/g, "");

    if(cleanPhone.startsWith("90") && cleanPhone.length === 12) {
        cleanPhone = cleanPhone.slice(2);
    } else if(cleanPhone.startsWith("0") && cleanPhone.length === 11) {
        cleanPhone = cleanPhone.slice(1);
    }

    const phoneRegex = /^[2-5]\d{9}$/;
    return phoneRegex.test(cleanPhone);
};

export const passwordValidation = (text: string) => {
    const regex = /^(?=.*[a-zçğıöşü])(?=.*[A-ZÇĞİÖŞÜ])(?=.*\d)(?=.*[^a-zA-ZçğıöşüÇĞİÖŞÜ0-9\s]).{8,}$/;
    return regex.test(text);
};
